import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../lib/auth-store';

/**
 * QoL Slice 2 — gate inserted INSIDE `RequireAuth` and OUTSIDE the layout so a
 * user with `must_change_password=true` is forced to the change-password
 * screen before any other route can render. The change-password route itself
 * is rendered outside this gate so the user can actually reach it.
 */
export function RequirePasswordChange() {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  if (user?.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  return <Outlet />;
}
